module.exports = __webpack_public_path__ + "img/06_img.8973929a.png";